import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import Home from './components/Home/Home';
import GamePage from './components/GamePage/GamePage';
import Daily from './components/Daily/Daily';
import MenuBar from './components/MenuBar/MenuBar';
import Footer from './components/Footer/Footer';
import Credits from './components/Credits/Credits';
import AuthCallback from './components/AuthCallback/AuthCallback';
import Login from './components/Login/Login';
import UsernameSetup from './components/UsernameSetup/UsernameSetup';
import Profile from './components/Profile/Profile';
import PublicProfile from './components/Profile/PublicProfile';
import Settings from './components/Settings/Settings';
import Stats from './components/Stats/Stats';
import AchievementsPage from './components/Achievements/AchievementsPage';
import PublicAchievementsPage from './components/Achievements/PublicAchievementsPage';
import Leaderboard from './components/Leaderboard/Leaderboard';
import AdminPage from './components/AdminPage/AdminPage';
import AccountCreated from './components/AccountCreated/AccountCreated';
import RouteProtection from './components/RouteProtection/RouteProtection';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import TermsOfService from './components/Legal/TermsOfService';
import Updates from './components/Updates/Updates';
import BadgeDisplay from './components/Dev/BadgeDisplay';
import UserDev from './components/Dev/UserDev';

import './App.scss';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ToastProvider>
          <Router>
          <div className="app">
            <RouteProtection />
            <MenuBar />
            <main className="app__main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/daily" element={<Daily />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/solve/:gameId" element={<GamePage />} />
                <Route path="/credits" element={<Credits />} />
                <Route path="/login" element={<Login />} />
                <Route path="/username-setup" element={<UsernameSetup />} />
                <Route path="/profile/:username/achievements" element={<PublicAchievementsPage />} />
                <Route path="/profile/:username" element={<PublicProfile />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/achievements" element={<AchievementsPage />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/stats" element={<Stats />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/account-created" element={<AccountCreated />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/updates" element={<Updates />} />
                {/* Development routes - only available in development */}
                {process.env.NODE_ENV === 'development' && (
                  <>
                    <Route path="/dev/auth-callback" element={<AuthCallback />} />
                    <Route path="/dev/username-setup" element={<UsernameSetup />} />
                    <Route path="/dev/account-created" element={<AccountCreated />} />
                    <Route path="/dev/badge-display" element={<BadgeDisplay />} />
                    <Route path="/dev/user" element={<UserDev />} />
                  </>
                )}
                {/* Catch-all route for 404s - redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;